import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { AuthService } from '../login/service/login-service/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    TranslateModule
  ],
  template: `
    <div class="not-found-container">
      <mat-card class="not-found-card">
        <mat-card-content>
          <div class="not-found-content">
            <div class="error-code">404</div>
            <h1 class="error-title">{{ 'errorPage.title' | translate }}</h1>
            <p class="error-message">
              {{ 'errorPage.message' | translate }}
            </p>
            <div class="actions">
              <button mat-raised-button color="primary" (click)="goToDashboard()">
                <mat-icon>home</mat-icon>
                {{ 'errorPage.goToDashboard' | translate }}
              </button>
              <button mat-button routerLink="/login">
                <mat-icon>login</mat-icon>
                {{ 'errorPage.backToLogin' | translate }}
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  `,
  styles: [`
    .not-found-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      padding: 20px;
      background: white;
    }

    .not-found-card {
      max-width: 600px;
      width: 100%;
      text-align: center;
    }

    .not-found-content {
      padding: 40px 20px;
    }

    .error-code {
      font-size: 120px;
      font-weight: 700;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      line-height: 1;
      margin-bottom: 20px;
    }

    .error-title {
      font-size: 32px;
      font-weight: 600;
      color: #1f2937;
      margin: 0 0 16px 0;
    }

    .error-message {
      font-size: 16px;
      color: #6b7280;
      margin: 0 0 32px 0;
      line-height: 1.6;
    }

    .actions {
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;
    }

    .actions button {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    @media (max-width: 600px) {
      .error-code {
        font-size: 80px;
      }

      .error-title {
        font-size: 24px;
      }

      .error-message {
        font-size: 14px;
      }

      .actions {
        flex-direction: column;
      }

      .actions button {
        width: 100%;
      }
    }
  `]
})
export class NotFoundComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  goToDashboard(): void {
    const user = this.authService.user();
    
    // Check if user is Admin
    if (user && user.role === 'Admin') {
      this.router.navigate(['/admin/dashboard']);
    } else {
      // Regular user dashboard
      this.router.navigate(['/dashboard']);
    }
  }
}

